import { Loading1Icon } from "@/components/icons/quiz/loading1.icon";
import { Loading2Icon } from "@/components/icons/quiz/loading2.icon";
import { Loading3Icon } from "@/components/icons/quiz/loading3.icon";
import { Loading4Icon } from "@/components/icons/quiz/loading4.icon";
import { Text } from "@/components/text/text.component";

import { QuizData } from "./quizFlow.types";

export const QuizFlowLoader = ({ quiz }: { quiz: QuizData }) => (
  <div
    data-testid="quiz-loading"
    className="flex flex-col items-center gap-6 py-16">
    <div
      data-testid="quiz-loading-icons"
      className="flex h-24 items-center justify-center gap-4 overflow-visible">
      {[Loading1Icon, Loading2Icon, Loading3Icon, Loading4Icon].map(
        (Icon, index) => (
          <Icon
            key={index}
            data-testid="quiz-loading-icon"
            aria-hidden="true"
            className="h-10 w-10 origin-center animate-[quiz-loading-icon_4.8s_cubic-bezier(0.4,0,0.2,1)_infinite]"
            style={{ animationDelay: `${index * 1.2}s` }}
          />
        ),
      )}
    </div>
    <Text
      variant="h3"
      component="h2"
      data-testid="quiz-loading-title"
      className="text-greyscale-headline text-center">
      {quiz.loadingState?.title ?? "Blu's got you covered"}
    </Text>
    <Text
      variant="body1"
      data-testid="quiz-loading-description"
      className="text-greyscale-body max-w-lg text-center">
      {quiz.loadingState?.description ??
        "One moment while we prepare your customized security system."}
    </Text>
  </div>
);
